const isDev = false
export const BASE_URL = isDev ? 'http://localhost/surveystud/api' : 'https://surveystud.com:81/api';
export const ROOT_URL = isDev ? 'http://localhost/surveystud/' : 'https://surveystud.com:81/';

export const fake = '';
